import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";
import './login.css';
import { API_URL, baseurl, projectNo } from "../../_config";
import { useNavigate } from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const getLoginDetailByMobileNo = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {
            // Sending the username and password to the server for login
            const response = await axios.post(`${baseurl}${API_URL.login}`,
                {
                    username: username,
                    password: password
                }
            );

            // Check if the response status is 200 (success)
            if (response?.data?.isSuccess === 1) {
                toast.success('Login successful');
                localStorage.setItem("isLoggedIn", "true");
                sessionStorage.setItem('userData', JSON.stringify(response?.data?.user));
                if (response?.data?.user?.role === 3) {
                    navigate('/partner-players');
                } else if (response?.data?.user?.role === 4) {
                    navigate('/passorderlist');
                } else if (response?.data?.user?.role === 5) {
                    navigate(`/team/${response?.data?.user?.id}`);
                } else if (response?.data?.user?.role === 2) {
                    navigate('/user-list');
                } else if (response?.data?.user?.role === 6) {
                    navigate('/matches-list');
                } else {
                    toast.error('Invalid credentials');
                }
            } else {
                toast.error('Invalid credentials');
            }
        } catch (error) {
            toast.error('Server Error. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login_main">
            <Toaster position="top-right" />
            <div className="login_form">
                <div className="login_logo_lifecode">
                    <img src={`./images/logonew.png`} alt="logo" />
                </div>
                <h3 className="text-center mb-3 login_heading">LOGIN</h3>
                <form onSubmit={getLoginDetailByMobileNo}>
                    <div className="form-group">
                        <label className="mb-1 mobile_label" htmlFor="username">Email Address</label>
                        <input
                            type="text"
                            className="form-control"
                            name="username"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}  // Handle input change
                            aria-describedby="emailHelp"
                            placeholder="Email Address"
                            required
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label className="mb-1 mobile_label" htmlFor="password">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}  // Handle input change
                            aria-describedby="passwordHelp"
                            placeholder="Password"
                            required
                        />
                    </div>

                    <div className="login_btn_wepper">
                        <button
                            type="submit"
                            className="login_btn"
                            disabled={loading}
                        >
                            {loading ? 'Logging In...' : 'Login'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
